import React from 'react';
import { motion } from 'framer-motion';
import PoojaLogin from '../pages/PoojaLogin';

const AuthModal = ({ open, initialMode = 'signin', onClose, onSuccess }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay auth-modal-overlay">
      <motion.div
        className="auth-modal-shell"
        initial={{ opacity: 0, y: 22, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 22, scale: 0.98 }}
        transition={{ duration: 0.24 }}
      >
        <PoojaLogin
          embedded
          initialMode={initialMode}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </motion.div>
    </div>
  );
};

export default AuthModal;
